import React, { Fragment } from 'react';
import styled from 'styled-components';

import DOLLAR_INCREMENTS from 'constants/dollarIncrements';
import EMOJI_MAP from 'constants/emojis';
import LOAN_TYPES from 'constants/loanTypes';
import { validDebt } from 'utils/validation';

import theme from 'styles/theme';

import Button from 'components/Button';
import Columns from 'components/Columns';
import Input from 'components/Input';
import Select from 'components/Select';

const StyledDebt = styled.div`
  display: flex;
  flex-flow: column;
  border-radius: 5px;
  border: 1px solid ${theme.B600};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);

  .Debt__emoji {
    display: inline-flex;
    margin-right: 8px;
    font-size: 20px;
  }

  .Debt__title {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background: ${theme.B400};
    border-bottom: 1px solid ${theme.B600};
    font-weight: 700;
    font-size: 18px;
    border-radius: 5px 5px 0 0;

    &-left {
      margin-right: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-right {
      margin-left: auto;
      white-space: nowrap;
    }
  }

  .Debt__content {
    flex: 1 1 auto;
    padding: 15px;
    background: ${theme.B500};
    border-radius: 0 0 5px 5px;
  }

  .Debt__field {
    margin: 0 0 15px;

    &:last-child {
      margin: 0;
    }
  }
`;

const IconButton = styled(Button)`
  color: ${props => (props.color ? props.color : `inherit`)};
  transition: color 300ms;

  &:hover {
    color: ${props => (props.hover ? props.hover : `inherit`)};
  }
`;

const Debt = ({ details, editing, onBalanceAction, onChange, onCancel, onEdit, onRemove, onSave }) => {
  const { name = '', type, dollarSpecificity, current, starting, interest } = details;

  const onFormSubmit = e => {
    e.preventDefault();

    if (validDebt(details)) {
      onSave(details);
    }
  };

  // TODO - Make Helper
  const onFieldChange = ({ target }) => {
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    onChange({ name, value });
  };

  return (
    <StyledDebt>
      <div className="Debt__title">
        <div className="Debt__title-left">
          {type && (
            <span className="Debt__emoji" role="img" aria-label={type}>
              {EMOJI_MAP[type]}
            </span>
          )}
          {name.length > 0 ? name : 'Debt'}
        </div>
        <div className="Debt__title-right">
          {!editing && (
            <Fragment>
              <IconButton icon="pencil-alt" hover="#bcbcbc" iconOnly transparent onClick={() => onEdit()} />
              <IconButton icon="trash-alt" hover={theme.red} iconOnly transparent onClick={() => onRemove(details)} />
            </Fragment>
          )}
          {editing && (
            <Fragment>
              <IconButton icon="check" hover={theme.green} iconOnly transparent disabled={!validDebt(details)} onClick={() => onSave(details)} />
              <IconButton icon="times" hover={theme.red} iconOnly transparent onClick={() => onCancel(details)} />
            </Fragment>
          )}
        </div>
      </div>
      <div className="Debt__content">
        <form noValidate onSubmit={onFormSubmit}>
          <div className="Debt__field">
            <Input label="Name" name="name" type="text" maxLength="24" disabled={!editing} onChange={onFieldChange} value={name} />
          </div>
          <div className="Debt__field">
            <Select label="Type" name="type" disabled={!editing} options={LOAN_TYPES} onChange={onFieldChange} value={type} />
          </div>
          <div className="Debt__field">
            <Input label="Current Balance" name="current" type="number" disabled={!editing} onChange={onFieldChange} value={current} />
          </div>
          <div className="Debt__field">
            <Input label="Highest Balance" name="starting" type="number" disabled={!editing} onChange={onFieldChange} value={starting} />
          </div>
          <div className="Debt__field">
            <Input label="Interest Rate" name="interest" type="number" disabled={!editing} onChange={onFieldChange} value={interest} />
          </div>
          <div className="Debt__field">
            <Select label="Dollar Block Size" name="dollarSpecificity" disabled={!editing} options={DOLLAR_INCREMENTS} onChange={onFieldChange} value={dollarSpecificity} />
          </div>
          <Button style={{ display: 'none' }} type="submit" />
        </form>
        {!editing && (
          <Columns span="2" gap="15">
            <Button disabled={editing} onClick={() => onBalanceAction('interest', details)}>
              Add Interest
            </Button>
            <Button disabled={editing} onClick={() => onBalanceAction('payment', details)}>
              Add Payment
            </Button>
          </Columns>
        )}
      </div>
    </StyledDebt>
  );
};

export default Debt;



// WEBPACK FOOTER //
// ./src/components/DebtEditable/DebtEditable.js